import type { ComponentType } from "react";
import type { AutomationEditorProps } from "./AutomationEditor";

interface EditorModule {
  default: ComponentType<AutomationEditorProps>;
}

/**
 * Ленивый чанк редактора (React Flow и его CSS). Модуль сам статически
 * ничего из редактора не тянет: только `import()`, поэтому его можно
 * импортировать из основного чанка (Automations, граница ошибки).
 */
export const loadAutomationEditor = (): Promise<EditorModule> =>
  import("./AutomationEditor").then((module) => ({
    default: module.AutomationEditor,
  }));

let preloading: Promise<EditorModule> | null = null;

/**
 * Загрузка чанка заранее, при открытии страницы автоматизаций (супер-ревью
 * кабинета 10): диалог тогда ждёт только сеть данных, а не данные и
 * следом чанк. Повторный вызов отдаёт тот же промис; отказ сбрасывается,
 * чтобы следующая попытка (lazy в границе ошибки) загрузила заново.
 */
export function preloadAutomationEditor(): Promise<EditorModule> {
  if (!preloading) {
    preloading = loadAutomationEditor().catch((error: unknown) => {
      preloading = null;
      throw error;
    });
  }
  return preloading;
}
